module.exports = __webpack_public_path__ + "media/images/logo-2529b5c8b0fdc571fc0b7ce965d54261.png";